import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createBlock as _createBlock, normalizeClass as _normalizeClass, Transition as _Transition } from "vue"

const _hoisted_1 = { class: "relative w-full" }
const _hoisted_2 = {
  key: 0,
  class: "inline-flex h-[18px] w-[18px] shrink-0 overflow-hidden rounded-full"
}
const _hoisted_3 = ["src", "alt"]
const _hoisted_4 = ["src"]
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 2,
  class: "relative ml-auto flex items-center gap-3"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Menu = _resolveComponent("Menu")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_favorites_header_link = _resolveComponent("favorites-header-link")!
  const _component_Search = _resolveComponent("Search")!
  const _component_active_gift_card = _resolveComponent("active-gift-card")!
  const _component_mobile_header_menu = _resolveComponent("mobile-header-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["flex h-14 items-center gap-3 px-4", _ctx.inverted ? 'text-background' : 'text-foreground'])
    }, [
      _createElementVNode("button", {
        type: "button",
        class: "btn-bare -ml-2 inline-flex items-center gap-2 p-2 text-inherit",
        "aria-label": "Open menu",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openMenu()))
      }, [
        _createVNode(_component_Menu, { class: "h-6 w-6" }),
        (_ctx.flagSrc)
          ? (_openBlock(), _createElementBlock("span", _hoisted_2, [
              _createElementVNode("img", {
                src: _ctx.flagSrc,
                alt: _ctx.countryCode,
                class: "h-full w-full object-cover"
              }, null, 8, _hoisted_3)
            ]))
          : _createCommentVNode("", true)
      ]),
      (!_ctx.onRootPath)
        ? (_openBlock(), _createBlock(_component_router_link, {
            key: 0,
            to: _ctx.rootPathRedirectUrl,
            class: "flex justify-center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                class: "mt-[5px] h-7 max-w-none",
                src: _ctx.logoUrl,
                alt: "logo"
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }, 8, ["to"]))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            class: "mt-[5px] h-7 max-w-none cursor-pointer",
            src: _ctx.logoUrl,
            alt: "logo",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.scrollToTop && _ctx.scrollToTop(...args)))
          }, null, 8, _hoisted_5)),
      (_ctx.hasAnyGiftCards)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_favorites_header_link, { class: "relative z-10 -m-3 p-3 text-inherit" }),
            _createElementVNode("button", {
              type: "button",
              "aria-label": "Search",
              class: "btn-bare relative z-10 -m-3 p-3 text-inherit transition-colors hover:opacity-70",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$mitt.emit('Search:Open')))
            }, [
              _createVNode(_component_Search, { class: "h-5 w-5" })
            ]),
            _createVNode(_component_active_gift_card, { class: "relative z-10 -m-3 p-3 text-inherit" })
          ]))
        : _createCommentVNode("", true)
    ], 2),
    _createVNode(_Transition, { name: "mobile-menu-overlay" }, {
      default: _withCtx(() => [
        (_ctx.showMenu)
          ? (_openBlock(), _createElementBlock("div", {
              key: 0,
              class: "fixed inset-0 z-40 bg-black/50",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.closeMenu()))
            }))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_Transition, { name: "mobile-menu-panel" }, {
      default: _withCtx(() => [
        (_ctx.showMenu)
          ? (_openBlock(), _createBlock(_component_mobile_header_menu, {
              key: 0,
              links: _ctx.links,
              "logo-url": _ctx.menuLogoUrl || _ctx.logoUrl,
              onClose: _ctx.closeMenu
            }, null, 8, ["links", "logo-url", "onClose"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}